import React, { useState, useContext } from "react";
import { ContextSession } from "../../services/ContextSession";
import {
    Container,
    Stack,
    Card,
    CardContent,
    Typography,
    TextField,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormControl,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    CircularProgress,
    Backdrop,
    Link
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import { useMediaQuery } from '@mui/material';

function QuejasSugerencias() {
    const sessi = useContext(ContextSession);
    const [tipoSeleccionado, setTipoSeleccionado] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [dialogOpen, setDialogOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const isMobile = useMediaQuery('(max-width:820px)');

    const handleTipoSeleccionado = (event) => {
        setTipoSeleccionado(event.target.value);
    };

    const handleDescripcionChange = (event) => {
        setDescripcion(event.target.value);
    };

    const handleEnviar = async () => {
        if (!tipoSeleccionado) {
            setErrorMessage("Debe seleccionar un tipo.");
            setDialogOpen(true);
            return;
        }
        if (!descripcion.trim()) {
            setErrorMessage("La descripción no puede estar vacía.");
            setDialogOpen(true);
            return;
        }

        setLoading(true);

        const tipoValor = tipoSeleccionado === "Queja" ? 1 : 2;
        const formData = new FormData();
        formData.append("tipo", tipoValor);
        formData.append("descripcion", descripcion);
        formData.append("estado", "Pendiente");
        formData.append("idusuarioparticipante", sessi.sessionData.id);

        try {
            const response = await fetch(`${sessi.ip}/api/quejasSugerencia/registrar/`, {
                method: "POST",
                body: formData,
                headers: {
                    Authorization: `Bearer ${sessi.sessionData.token}`,
                },
            });

            if (response.ok) {
                setSuccessMessage(
                    `Tu ${tipoSeleccionado} fue enviada con éxito. Recibirás una respuesta en un plazo máximo de 10 días hábiles.`
                );
                setDialogOpen(true);
                setTipoSeleccionado("");
                setDescripcion("");
            } else {
                setErrorMessage("Ocurrió un error al enviar los datos. Inténtalo de nuevo.");
                setDialogOpen(true);
            }
        } catch (error) {
            setErrorMessage("Ocurrió un error al enviar los datos. Inténtalo de nuevo.");
            setDialogOpen(true);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    return (
        <>
            <Container sx={{ mt: isMobile ? 1 : 5 }}>
                <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
                    Quejas y Sugerencias
                </Typography>
                <Typography variant="subtitle1" textAlign={isMobile ? "justify" : 'center'} color="text.secondary" sx={{ mb: 3 }}>
                    Canal exclusivo para envío de quejas y sugerencias. Si lo que deseas es realizar una consulta puedes contactar a nuestro call center al{' '}
                    <Link
                        href="tel:+50422901900"
                        sx={{
                            color: '#89CFF0', // azul celeste
                            display: 'inline-flex',
                            alignItems: 'center',
                            textDecoration: 'none',
                            ml: 0.5,
                            '&:hover': {
                                color: 'black', // un azul celeste un poco más fuerte al pasar el mouse
                            },
                        }}
                        style={{ textDecoration: 'underline' }}
                    >
                        +504 2290-1900
                    </Link>
                    {' '} o a través de nuestro chatbot de Whatsapp{' '}
                    <Link href={'https://wa.link/kbcxjr'} color="primary" target="_blank" style={{ textDecoration: 'underline' }}>
                        Pulsando Aquí.
                    </Link>
                </Typography>
                {/*<Typography variant="subtitle1" textAlign="justify" color="text.secondary" sx={{ mb: 3 }}>
                    Ayúdanos a mejorar compartiendo tus quejas o sugerencias.  Si lo que deseas es realizar una consulta,{" "}
                    <Link
                        style={{
                            color: "black",
                            fontWeight: "bold",
                            textDecoration: "underline"
                        }}
                        to="/Buzón"
                        onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                        onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                    >
                        pulsa aquí
                    </Link>{" "}
                    para enviar el mensaje desde tu buzón o comunicate a nuestro call center {" "}
                    <Link
                        href="tel:+50422901900"
                        style={{
                            color: "black",
                            fontWeight: "bold",
                            textDecoration: "underline"
                        }}
                        onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                        onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                    >
                        (+504) 2290-1900
                    </Link>{" "} y pulsa la opción número 3 para contactarte con uno de nuestros agentes.
                </Typography>*/}
                <Card
                    sx={{
                        boxShadow: 3,
                        borderRadius: 2,
                        p: 2,
                        backgroundColor: "#f9f9f9",
                    }}
                >
                    <CardContent>
                        <Stack spacing={3}>
                            <FormControl>
                                <Divider>
                                    <b><Chip label="SELECCIONA EL TIPO:" size="small" /></b>
                                </Divider>
                                <RadioGroup
                                    value={tipoSeleccionado}
                                    onChange={handleTipoSeleccionado}
                                    row
                                    sx={{ justifyContent: "center" }}
                                >
                                    <FormControlLabel
                                        value="Queja"
                                        control={<Radio color="error" variant="solid" />}
                                        label="Queja"
                                        sx={{ "& .MuiTypography-root": { fontWeight: "bold" } }}
                                    />
                                    <FormControlLabel
                                        value="Sugerencia"
                                        control={<Radio color="error" variant="solid" />}
                                        label="Sugerencia"
                                        sx={{ "& .MuiTypography-root": { fontWeight: "bold" } }}
                                    />
                                </RadioGroup>
                            </FormControl>

                            <TextField
                                label="Escribe tu descripción aquí"
                                placeholder="Describe tu queja o sugerencia..."
                                multiline
                                rows={4}
                                fullWidth
                                value={descripcion}
                                onChange={handleDescripcionChange}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: 2,
                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "primary.main",
                                        },
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "primary.main",
                                            borderWidth: 2,
                                        },
                                    },
                                }}
                            />

                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleEnviar}
                                endIcon={<SendIcon />}
                                sx={{
                                    alignSelf: "center",
                                    px: 4,
                                    py: 1.5,
                                    fontWeight: "bold",
                                    textTransform: "none",
                                    borderRadius: 3,
                                }}
                                disabled={loading}
                            >
                                {loading ? "Enviando..." : "Enviar"}
                            </Button>
                        </Stack>
                    </CardContent>
                </Card>

            </Container>

            <Backdrop open={loading} sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Dialog open={dialogOpen} onClose={handleCloseDialog}>
                <DialogTitle>
                    {successMessage ? "¡Éxito!" : "Error"}
                </DialogTitle>
                <DialogContent>
                    <Stack direction="row" alignItems="center" spacing={2}>
                        {successMessage ? (
                            <CheckCircleOutlineIcon sx={{ color: "green", fontSize: 40 }} />
                        ) : (
                            <ErrorOutlineIcon sx={{ color: "var(--color-brand-secondary)", fontSize: 40 }} />
                        )}
                        <Typography variant="body1">{successMessage || errorMessage}</Typography>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} variant="contained" color="primary">
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default QuejasSugerencias;
